import { createReducer } from 'src/helpers/reducer';
import actionTypes from './actionTypes';
import type { IRateEngineListState, ILoadDataSuccessPayload } from './types';

const initState: IRateEngineListState = {
  rateEngines: null,
  loading: false,
  loadFailed: false,
  filteredTotal: 0,
  sortableColumns: [],
  total: 0,
};

function onLoadRequest(state: IRateEngineListState): IRateEngineListState {
  return {
    ...state,
    loading: true,
    loadFailed: false,
  };
}

function onLoadSuccess(
  state: IRateEngineListState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IRateEngineListState {
  const { records, total, filteredTotal, sortableColumns } = payload;

  return {
    ...state,
    rateEngines: records,
    sortableColumns,
    total,
    filteredTotal,
    loading: false,
    loadFailed: false,
  };
}

// loadFailed separates a failed load from an empty result; otherwise the table shows "no matches" after an error.
function onLoadError(state: IRateEngineListState): IRateEngineListState {
  return {
    ...state,
    loading: false,
    loadFailed: true,
  };
}

export default createReducer(initState, {
  [actionTypes.LOAD_DATA_REQUEST]: onLoadRequest,
  [actionTypes.LOAD_DATA_SUCCESS]: onLoadSuccess,
  [actionTypes.LOAD_DATA_ERROR]: onLoadError,
  [actionTypes.CLEAR_STORE]: () => initState,
});
